import type { LocaleBundle } from '../types.js'

export const es: LocaleBundle = {
  code: 'es',
  name: 'Español',
  dict: {
    'common:appName': 'Modern Admin',
    'common:home': 'Inicio',
    'common:search': 'Buscar',
    'common:loading': 'Cargando…',
    'common:save': 'Guardar',
    'common:cancel': 'Cancelar',
    'common:delete': 'Eliminar',
    'common:create': 'Crear',
    'common:edit': 'Editar',
    'common:show': 'Ver',
    'common:back': 'Atrás',
    'common:noRecords': 'No hay registros.',
    'common:noRecordsHint': 'Comience creando un nuevo {resource}.',
    'common:noMatchingRecords': 'Ningún registro coincide con tus filtros.',
    'common:clearFilters': 'Borrar filtros',
    'common:confirmDelete': '¿Eliminar este registro?',
    'common:confirmAction': 'Confirmar acción',
    'common:confirm': 'Confirmar',
    'common:perPage': 'Por página',
    'common:page': 'Página',
    'common:of': 'de',
    'common:total': 'Total',
    'auth:login': 'Iniciar sesión',
    'auth:logout': 'Cerrar sesión',
    'auth:email': 'Correo',
    'auth:password': 'Contraseña',
    'auth:loginFailed': 'Credenciales no válidas.',
    'errors:notFound': 'No encontrado.',
    'errors:forbidden': 'No tienes acceso a este recurso.',
    'errors:server': 'Algo salió mal. Inténtalo de nuevo.',
    'common:resources': 'Recursos',
    'common:actions': 'Acciones',
    'action:notFound': 'La acción «{action}» no está disponible en este recurso.',
    'action:componentMissing': 'No hay ningún componente llamado «{component}» registrado.',
    'action:componentMissingHint': 'Regístralo en el ComponentLoader que pasas a <ModernAdminProvider components={…}>.',
    'action:loadFailed': 'No se pudo cargar la acción.',
    'common:new': 'Nuevo',
    'common:rowsPerPage': 'Filas por página',
    'common:filter': 'Filtrar {label}…',
    'validation:required': '{label} es obligatorio',
    'validation:invalidNumber': '{label} debe ser un número válido',
    'validation:invalidInteger': '{label} debe ser un entero',
    'validation:invalidEmail': '{label} debe ser un correo válido',
    'validation:invalidUrl': '{label} debe ser una URL válida',
    'validation:invalidDate': '{label} debe ser una fecha válida',
    'validation:invalidUuid': '{label} debe ser un UUID válido',
    'validation:tooShort': '{label} debe tener al menos {min} caracteres',
    'validation:tooLong': '{label} debe tener como máximo {max} caracteres',
    'validation:notInList': '{label} tiene un valor no válido',
    'validation:emptySelection': 'Selecciona al menos un valor para {label}',
    'toast:created': 'Creado correctamente',
    'toast:saved': 'Guardado correctamente',
    'toast:deleted': 'Eliminado correctamente',
    'toast:createFailed': 'Error al crear',
    'toast:saveFailed': 'Error al guardar',
    'toast:deleteFailed': 'Error al eliminar',
    'toast:loadFailed': 'Error al cargar',
    'toast:validationFailed': 'Corrige los errores e inténtalo de nuevo',
    'common:close': 'Cerrar',
    'common:export': 'Exportar',
    'export:title': 'Exportar registros',
    'export:description': 'Descargar todos los registros coincidentes de {resource} en un único archivo.',
    'export:csvHint': 'Valores separados por comas',
    'export:jsonHint': 'Array JSON estructurado',
    'export:downloading': 'Preparando descarga…',
    'export:progress': 'Cargados {loaded} de {total}…',
    'export:exported': '{count} registros exportados',
    'export:exportFailed': 'Error al exportar registros',
    'common:apply': 'Aplicar',
    'common:clear': 'Limpiar',
    'common:filters': 'Filtros',
    'common:columns': 'Columnas',
    'common:toggleColumns': 'Mostrar columnas',
    'common:openMenu': 'Abrir menú',
    'common:refresh': 'Actualizar',
    'common:copy': 'Copiar',
    'common:copied': '¡Copiado!',
    'common:applyFilters': 'Aplicar filtros',
    'common:clearAll': 'Limpiar todo',
    'common:any': 'Cualquiera',
    'common:yes': 'Sí',
    'common:no': 'No',
    'common:filterPlaceholder': 'Filtrar…',
    'common:loadFailed': 'Error al cargar: {error}',
    'common:theme': 'Tema',
    'common:language': 'Idioma',
    'common:toggleTheme': 'Cambiar tema',
    'common:clearSelection': 'Borrar selección',
    'common:searchPlaceholder': 'Buscar…',
    'home:searchResources': 'Buscar recursos…',
    'home:noMatchingResources': 'No se encontraron recursos coincidentes.',
    'globalSearch:title': 'Búsqueda global',
    'globalSearch:description': 'Buscar en todos los recursos y registros.',
    'globalSearch:trigger': 'Buscar…',
    'globalSearch:placeholder': 'Buscar en todos los recursos…',
    'globalSearch:hint': 'Empieza a escribir para buscar en todos los recursos.',
    'globalSearch:noResults': 'No se encontraron registros coincidentes.',
    'globalSearch:error': 'Error en la búsqueda. Inténtalo de nuevo.',
    'globalSearch:hotkey': 'Abrir búsqueda global',
    'globalSearch:matchedIn': 'en {field}',
    'globalSearch:recent': 'Búsquedas recientes',
    'globalSearch:clearRecent': 'Borrar',
    'globalSearch:showAllIn': 'Ver todo en {resource}',
    'common:pageOf': 'Página {page} de {total}',
    'common:firstPage': 'Primera página',
    'common:previousPage': 'Página anterior',
    'common:nextPage': 'Página siguiente',
    'common:lastPage': 'Última página',
    'common:recordsCount': '{count} registros',
    'common:selectedCount': '{count} seleccionados',
    'common:selectRow': 'Seleccionar fila',
    'common:selectAll': 'Seleccionar todo',
    'common:deleteSelected': 'Eliminar seleccionados',
    'common:bulkDeleteConfirm': '¿Eliminar {count} registros seleccionados?',
    'toast:bulkDeleted': '{count} registros eliminados',
    'toast:bulkDeleteFailed': 'Error al eliminar los registros',
    'common:from': 'Desde',
    'common:to': 'Hasta',
    'common:sortBy': 'Ordenar por',
    'common:next': 'Siguiente',
    'common:previous': 'Anterior',
    'common:relatedRecords': 'Registros relacionados',
    'common:viewAll': 'Ver todos',
    'common:noRelatedRecords': 'Sin registros relacionados.',
    'common:preview': 'Vista previa',
    'common:download': 'Descargar',
    'common:openInNewTab': 'Abrir en una pestaña nueva',
    'common:format': 'Formatear',
    'common:invalidJson': 'JSON inválido',
    'common:showPassword': 'Mostrar contraseña',
    'common:hidePassword': 'Ocultar contraseña',
    'common:shortcutsHelp': 'Atajos de teclado',
    'common:shortcutsEmpty': 'No hay atajos disponibles en esta pantalla.',
    'auth:title': 'Iniciar sesión',
    'auth:subtitle': 'Ingrese su correo y contraseña para iniciar sesión',
    'auth:tagline': 'El panel de administración moderno para cualquier stack.',
    'auth:orContinueWith': 'O continuar con',
    'auth:continueWith': 'Continuar con {provider}',
    'common:chooseFile': 'Elegir archivo',
    'common:chooseFiles': 'Elegir archivos',
    'common:dragAndDrop': 'Arrastra y suelta o',
    'common:chooseAFile': 'elegir un archivo',
    'common:addMoreFiles': 'agregar más archivos',
    'common:uploading': 'Subiendo…',
    'common:uploadingFile': 'Subiendo {name}…',
    'common:removeFile': 'Quitar archivo',
    'common:uploadFailed': 'Error al subir',
    'common:dismiss': 'Cerrar',
    'common:openCalendar': 'Abrir calendario',
    'common:time': 'Hora',
    'common:downloadFailed': 'Error al descargar',
    'richtext:bold': 'Negrita',
    'richtext:italic': 'Cursiva',
    'richtext:strikethrough': 'Tachado',
    'richtext:inlineCode': 'Código en línea',
    'richtext:heading': 'Encabezado {level}',
    'richtext:bulletList': 'Lista con viñetas',
    'richtext:numberedList': 'Lista numerada',
    'richtext:blockquote': 'Cita en bloque',
    'richtext:horizontalRule': 'Línea horizontal',
    'richtext:insertLink': 'Insertar enlace',
    'richtext:undo': 'Deshacer',
    'richtext:redo': 'Rehacer',
    'richtext:source': 'Fuente ({format})',
    'richtext:splitView': 'Vista dividida',
    'richtext:visualEditor': 'Editor visual',
    'richtext:fullscreen': 'Pantalla completa',
    'richtext:exitFullscreen': 'Salir de pantalla completa',
    'richtext:urlPrompt': 'URL',
    'common:saving': 'Guardando…',
    'common:done': 'Listo',
    'settings:menuItem': 'Ajustes',
    'settings:noSectionsConfigured': 'No hay secciones de ajustes disponibles en esta instalación.',
    'settings:apiKeys.title': 'Claves de API',
    'settings:apiKeys.description': 'Tokens de acceso programático a la API de administración. Cada clave incluye un conjunto de permisos que limita los recursos y acciones que puede invocar.',
    'settings:apiKeys.actions.create': 'Nueva clave',
    'settings:apiKeys.actions.edit': 'Editar',
    'settings:apiKeys.actions.revoke': 'Revocar',
    'settings:apiKeys.empty.title': 'Aún no hay claves',
    'settings:apiKeys.empty.description': 'Crea tu primera clave para conceder acceso programático.',
    'settings:apiKeys.columns.name': 'Nombre',
    'settings:apiKeys.columns.start': 'Prefijo',
    'settings:apiKeys.columns.permissions': 'Permisos',
    'settings:apiKeys.columns.expiresAt': 'Expira',
    'settings:apiKeys.columns.enabled': 'Activa',
    'settings:apiKeys.columns.actions': 'Acciones',
    'settings:apiKeys.lastUsed': 'Último uso {date}',
    'settings:apiKeys.expiresNever': 'Nunca',
    'settings:apiKeys.permissions.resource': 'Recurso',
    'settings:apiKeys.permissions.actions': 'Acciones',
    'settings:apiKeys.permissions.selectAll': 'Seleccionar todo',
    'settings:apiKeys.permissions.clearAll': 'Limpiar todo',
    'settings:apiKeys.permissions.none': 'Sin permisos',
    'settings:apiKeys.permissions.summary': '{resources} recursos · {actions} acciones',
    'settings:apiKeys.permissions.noResources': 'No hay recursos registrados.',
    'settings:apiKeys.permissions.selectAllResources': 'Seleccionar todos los recursos y acciones',
    'settings:apiKeys.permissions.clearAllResources': 'Borrar todos los recursos y acciones',
    'settings:apiKeys.editor.titleCreate': 'Nueva clave de API',
    'settings:apiKeys.editor.titleEdit': 'Editar clave de API',
    'settings:apiKeys.editor.description': 'Elige un nombre descriptivo y concede solo los recursos y acciones que esta clave necesita.',
    'settings:apiKeys.editor.name': 'Nombre',
    'settings:apiKeys.editor.namePlaceholder': 'p. ej. bot de despliegue CI',
    'settings:apiKeys.editor.expiresInDays': 'Expira en (días)',
    'settings:apiKeys.editor.expiresPlaceholder': 'nunca',
    'settings:apiKeys.editor.expiresHint': 'Déjalo en blanco para que no caduque. Máximo 3650 días.',
    'settings:apiKeys.editor.permissions': 'Permisos',
    'settings:apiKeys.editor.selectedActions': '{count} seleccionadas',
    'settings:apiKeys.created.title': 'Clave de API creada',
    'settings:apiKeys.created.description': 'Copia la clave ahora — no se mostrará de nuevo.',
    'settings:apiKeys.created.warning': 'Esta es la única vez que verás la clave completa. Guárdala en un lugar seguro.',
    'settings:apiKeys.created.reveal': 'Mostrar clave',
    'settings:apiKeys.created.hide': 'Ocultar clave',
    'settings:apiKeys.created.copy': 'Copiar',
    'settings:apiKeys.created.copied': 'Copiada',
    'settings:apiKeys.notice.revoked': 'Clave de API revocada',
    'settings:apiKeys.notice.updated': 'Clave de API actualizada',
    'settings:apiKeys.notice.copied': 'Copiada al portapapeles',
    'settings:apiKeys.notice.copyFailed': 'No se pudo copiar al portapapeles',
    'settings:apiKeys.confirmRevoke.title': 'Revocar clave de API',
    'settings:apiKeys.confirmRevoke.description': '¿Revocar «{name}»? Cualquier servicio que use esta clave dejará de funcionar inmediatamente.',
    'settings:webhooks.title': 'Webhooks',
    'settings:webhooks.description': 'Send signed HTTP notifications when records are created, updated, or deleted.',
    'settings:webhooks.actions.create': 'New webhook',
    'settings:webhooks.actions.test': 'Test',
    'settings:webhooks.notice.saved': 'Webhook saved',
    'settings:webhooks.notice.deleted': 'Webhook deleted',
    'settings:webhooks.notice.testQueued': 'Test notification queued',
    'settings:webhooks.confirmDelete.title': 'Delete webhook',
    'settings:webhooks.confirmDelete.description': 'Delete "{name}"? Delivery history for this webhook will also be removed.',
    'settings:webhooks.empty.title': 'No webhooks yet',
    'settings:webhooks.empty.description': 'Create a webhook to notify external systems about admin changes.',
    'settings:webhooks.columns.name': 'Name',
    'settings:webhooks.columns.resource': 'Resource',
    'settings:webhooks.columns.events': 'Events',
    'settings:webhooks.columns.enabled': 'Enabled',
    'settings:webhooks.columns.actions': 'Actions',
    'settings:webhooks.deliveries.title': 'Recent deliveries',
    'settings:webhooks.deliveries.status': 'Status',
    'settings:webhooks.deliveries.event': 'Event',
    'settings:webhooks.deliveries.attempt': 'Attempt',
    'settings:webhooks.deliveries.response': 'Response',
    'settings:webhooks.deliveries.createdAt': 'Created',
    'settings:webhooks.editor.titleCreate': 'New webhook',
    'settings:webhooks.editor.titleEdit': 'Edit webhook',
    'settings:webhooks.editor.description': 'Choose target URL, events, filters, and optional payload projection.',
    'settings:webhooks.editor.name': 'Name',
    'settings:webhooks.editor.url': 'URL',
    'settings:webhooks.editor.resource': 'Resource',
    'settings:webhooks.editor.allResources': 'All resources',
    'settings:webhooks.editor.secret': 'Signing secret',
    'settings:webhooks.editor.enabled': 'Enabled',
    'settings:webhooks.editor.events': 'Events',
    'settings:webhooks.editor.payloadFields': 'Payload fields',
    'settings:webhooks.editor.payloadFieldsHint': 'Restrict the payload to specific fields. Leave all unchecked to include the full record. Useful to avoid sending sensitive columns.',
    'settings:webhooks.editor.headers': 'Headers',
    'settings:webhooks.editor.headersHint': 'Custom HTTP headers sent with every delivery.\n\nExample:\n{\n  "Authorization": "Bearer <token>",\n  "X-Source": "modern-admin"\n}\n\nUseful for auth tokens, Slack incoming webhook URLs stored as a header, or endpoint-specific signatures.',
    'settings:webhooks.editor.filters': 'Filters',
    'settings:webhooks.editor.filtersHint': 'Deliver only when the record matches all conditions (AND semantics). Leave empty to deliver for every matching event.\n\nExample:\n{\n  "status": "published",\n  "role": "admin"\n}\n\nNote: delete events bypass field filters because the record no longer exists.',
    'settings:webhooks.editor.secretHint': 'Random string used to sign each delivery with HMAC-SHA256. Verify the X-Webhook-Signature header on your server to ensure the request is genuine.',
    'chart:dashboard': 'Panel de control',
    'chart:addChart': 'Añadir gráfico',
    'chart:newChart': 'Nuevo gráfico',
    'chart:editChart': 'Editar gráfico',
    'chart:deleteChart': 'Eliminar gráfico',
    'chart:noCharts': 'Sin gráficos todavía',
    'chart:noChartsHint': 'Añada un gráfico para empezar a monitorear sus datos.',
    'chart:addGroup': 'Añadir grupo',
    'chart:newGroup': 'Nuevo grupo',
    'chart:editGroup': 'Editar grupo',
    'chart:deleteGroup': 'Eliminar grupo',
    'chart:saveGroup': 'Guardar grupo',
    'chart:groupName': 'Nombre del grupo',
    'chart:groupNamePlaceholder': 'p. ej. Métricas de ventas',
    'chart:groupNameRequired': 'El nombre del grupo es obligatorio',
    'chart:groupOrder': 'Orden del grupo',
    'chart:order': 'Orden',
    'chart:orderHint': 'Los valores menores aparecen primero.',
    'chart:moveToGroup': 'Mover al grupo',
    'chart:moveChart': 'Mover gráfico',
    'chart:moveGroup': 'Grupo',
    'chart:moveNoGroups': 'Aún no hay grupos.',
    'chart:moveNoGroupsHint': 'Crea un grupo primero para organizar tus gráficos.',
    'chart:deleteChartConfirm': '¿Eliminar este gráfico?',
    'chart:deleteChartConfirmHint': 'Esta acción no se puede deshacer.',
    'chart:deleteGroupConfirm': '¿Eliminar este grupo?',
    'chart:deleteGroupConfirmHint': 'Esto eliminará permanentemente el grupo y los {count} gráfico(s) que contiene.',
    'chart:title': 'Título',
    'chart:titlePlaceholder': 'p. ej. Nuevos usuarios por día',
    'chart:untitled': 'Sin título',
    'chart:chartType': 'Tipo de gráfico',
    'chart:resource': 'Recurso',
    'chart:groupBy': 'Agrupar por',
    'chart:step': 'Paso',
    'chart:metric': 'Métrica',
    'chart:aggregateField': 'Campo de agregación',
    'chart:selectField': 'Seleccionar campo…',
    'chart:saveChart': 'Guardar gráfico',
    'chart:typeLine': 'Líneas',
    'chart:typeArea': 'Área',
    'chart:typeBar': 'Barras',
    'chart:typePie': 'Circular',
    'chart:stepDay': 'Día',
    'chart:stepWeek': 'Semana',
    'chart:stepMonth': 'Mes',
    'chart:stepYear': 'Año',
    'chart:metricCount': 'Recuento',
    'chart:metricSum': 'Suma',
    'chart:metricAvg': 'Promedio',
    'chart:noData': 'Sin datos para el período seleccionado',
    'chart:loadError': 'Error al cargar los datos del gráfico',
    'chart:value': 'Valor',
    'dashboard:vis': 'Visualización',
    'dashboard:visKpi': 'KPI',
    'dashboard:visLine': 'Líneas',
    'dashboard:visArea': 'Área',
    'dashboard:visBar': 'Barras',
    'dashboard:visPie': 'Circular',
    'dashboard:metricCount': 'Cantidad',
    'dashboard:metricSum': 'Suma',
    'dashboard:metricAvg': 'Promedio',
    'dashboard:metricMin': 'Mínimo',
    'dashboard:metricMax': 'Máximo',
    'dashboard:builder.range': 'Rango temporal',
    'dashboard:builder.filters': 'Filtros',
    'dashboard:builder.filtersHint': 'Acotar el conjunto antes de agregar. Marca un filtro para exponerlo encima del gráfico.',
    'dashboard:builder.quickFilterHint': 'Mostrar este filtro encima del gráfico en el panel.',
    'dashboard:builder.quickFilterToggle': 'Exponer {field} como filtro rápido',
    'dashboard:range.7d': '7d',
    'dashboard:range.30d': '30d',
    'dashboard:range.90d': '90d',
    'dashboard:range.1y': '1a',
    'dashboard:range.all': 'Todo',
    'dashboard:range.custom': 'Personalizado',
    'dashboard:widget.previousPeriod': 'vs. período anterior',
    'dashboard:widget.deltaUp': '+{value} ({percent}%)',
    'dashboard:widget.deltaDown': '−{value} ({percent}%)',
    'dashboard:widget.deltaFlat': '{value} ({percent}%)',
    'dashboard:widget.shrink': 'Reducir a la mitad',
    'dashboard:widget.expand': 'Expandir a fila completa',
    'dashboard:widget.toggleSql': 'Mostrar SQL',
    'dashboard:widget.unsupported': 'Los gráficos aún no son compatibles con tu base de datos.',
    'dashboard:widget.truncatedWarning': 'Mostrando datos parciales: demasiadas filas para agregar todo el rango.',
    'dashboard:widget.showAll': 'Mostrar todo',
    'dashboard:widget.hideAll': 'Ocultar todo',
    'dashboard:seriesTotal': 'Total',
    'dashboard:seriesOther': 'Otros',
    'dashboard:seriesNull': 'Vacío',
    'dashboard:builder.dateField': 'Campo de fecha',
    'dashboard:builder.dateFieldHint': 'El eje X se agrupa por esta columna de fecha.',
    'dashboard:builder.secondaryGroupBy': 'Desglose',
    'dashboard:builder.noBreakdown': 'Serie única',
    'dashboard:builder.topN': 'Máx. series',
    'dashboard:builder.width': 'Ancho',
    'dashboard:width.half': 'Mitad',
    'dashboard:width.full': 'Completo',
    'dashboard:builder.comparePrevious': 'Comparar con el período anterior',
    'dashboard:builder.comparePreviousHint': 'Superpone el período anterior de igual duración como línea discontinua y muestra el cambio junto al título.',
    'dashboard:builder.comparePreviousDisabled': 'No disponible con un desglose.',
    'dashboard:builder.transform': 'Transformación de valores',
    'dashboard:builder.transformHint': 'Se aplica a los valores antes de mostrarlos — p. ej., dividir por 100 para mostrar centavos como dólares.',
    'dashboard:builder.transformAdd': 'Añadir paso',
    'dashboard:builder.transformRemove': 'Eliminar paso',
    'dashboard:builder.opDivide': 'Dividir por',
    'dashboard:builder.opMultiply': 'Multiplicar por',
    'dashboard:builder.opAdd': 'Sumar',
    'dashboard:builder.opSubtract': 'Restar',
    'dashboard:builder.format': 'Formato de valores',
    'dashboard:builder.formatStyle': 'Estilo',
    'dashboard:builder.formatNumber': 'Número',
    'dashboard:builder.formatCurrency': 'Moneda',
    'dashboard:builder.formatPercent': 'Porcentaje',
    'dashboard:builder.formatCurrencyCode': 'Código de moneda',
    'dashboard:builder.formatDecimals': 'Decimales',
    'dashboard:builder.formatCompact': 'Números compactos (12,5 mil)',
    'dashboard:builder.formatPrefix': 'Prefijo',
    'dashboard:builder.formatSuffix': 'Sufijo',
    'dashboard:builder.color': 'Color de la serie',
    'dashboard:widget.previousSeries': '{label} (período anterior)',
    'dashboard:widget.editColors': 'Editar colores',
    'dashboard:widget.colorsTitle': 'Colores de las series',
    'dashboard:widget.colorCustom': 'Personalizado',
    'dashboard:widget.colorAuto': 'Automático',
    'dashboard:widget.colorPick': 'Elegir un color',
    'dashboard:builder.tabData': 'Datos',
    'dashboard:builder.tabDisplay': 'Visualización',
    'dashboard:builder.tabFilters': 'Filtros',
    'dashboard:builder.filtersEmpty': 'Este recurso no tiene campos filtrables.',
    'history:revisions': 'Revisiones',
    'history:noRevisions': 'Aún no hay revisiones',
    'history:loadError': 'No se pudo cargar el historial de cambios',
    'history:revert': 'Revertir',
    'history:confirmRevert': '¿Revertir a esta revisión?',
    'history:revertSuccess': 'Revisión restaurada',
    'history:revertFailed': 'No se pudo restaurar la revisión',
    'history:unknownUser': 'Usuario desconocido',
    'history:changes': 'cambios',
    'history:compareTo': 'Comparar con',
    'history:storedDiff': 'Diff del cambio',
    'history:op.create': 'Creado',
    'history:op.update': 'Actualizado',
    'history:op.delete': 'Eliminado',
    'diff:added': 'Añadido',
    'diff:changed': 'Cambiado',
    'diff:removed': 'Eliminado',
    'diff:before': 'Antes',
    'diff:after': 'Después',
    'diff:noChanges': 'No se registraron cambios de campos',
    'audit:title': 'Actividad',
    'audit:resource': 'Recurso',
    'audit:action': 'Acción',
    'audit:recordId': 'ID de registro',
    'audit:userId': 'ID de usuario',
    'audit:allResources': 'Todos los recursos',
    'audit:allActions': 'Todas las acciones',
    'audit:noEvents': 'Aún no hay actividad',
    'audit:records': 'registros',
    'audit:loadError': 'No se pudo cargar la actividad',
    'audit:by': 'por {user}',
    'audit:viewRecord': 'Ver registro',
    'audit:viewChanges': 'Ver cambios',
    'audit:hideChanges': 'Ocultar cambios',
    'audit:noDiff': 'Detalles de los cambios no disponibles',
    'audit:loadDiffError': 'No se pudieron cargar los cambios',
    'audit:action.new': 'Registro creado',
    'audit:action.edit': 'Registro actualizado',
    'audit:action.delete': 'Registro eliminado',
    'audit:action.bulkDelete': 'Registros eliminados',
    'audit:action.login': 'Sesión iniciada',
    'audit:action.apiKeyCreate': 'Clave API creada',
    'audit:action.apiKeyUpdate': 'Clave API actualizada',
    'audit:action.apiKeyDelete': 'Clave API eliminada',
    'audit:virtualResource.auth': 'Autenticación',
    'audit:virtualResource.apiKeys': 'Claves API',
    'audit:prevPage': 'Anterior',
    'audit:nextPage': 'Siguiente',
    'audit:dateRangePlaceholder': 'Seleccionar rango de fechas',
    'keyValue:noMatches': 'Sin coincidencias — pulsa Enter para conservar "{value}".',
    'aiAssistant:queue.cancel': 'Quitar de la cola',
    'aiAssistant:title': 'Asistente IA',
    'aiAssistant:fab.label': 'Abrir asistente IA',
    'aiAssistant:fab.short': 'IA',
    'aiAssistant:description': 'Haz preguntas sobre registros, relaciones, informes y tendencias de datos.',
    'aiAssistant:notConfigured.title': 'El asistente no está configurado',
    'aiAssistant:notConfigured.description': 'Añade la clave API de OpenRouter en los ajustes para activar el asistente IA de solo lectura.',
    'aiAssistant:notConfigured.openSettings': 'Abrir ajustes',
    'aiAssistant:tryAsking': 'Pruebe a preguntar:',
    'aiAssistant:tryAsking.example1': '¿Qué clientes tienen más publicaciones?',
    'aiAssistant:tryAsking.example2': 'Muestra registros creados recientemente para un recurso.',
    'aiAssistant:tryAsking.example3': 'Explica relaciones entre registros concretos.',
    'aiAssistant:thinking': 'Pensando',
    'aiAssistant:thinkingProgress': 'Pensando ({progress}%)',
    'aiAssistant:input.placeholder': 'Pregunta sobre tus datos…',
    'aiAssistant:input.hint': 'Enter para enviar · Shift+Enter para una nueva línea',
    'aiAssistant:send': 'Enviar mensaje',
    'aiAssistant:newChat': 'Nuevo chat',
    'aiAssistant:history': 'Historial de chats',
    'aiAssistant:history.empty': 'No hay chats anteriores',
    'aiAssistant:noText': 'Aquí están los registros relacionados que encontré:',
    'aiAssistant:fallback.noToolResult': 'Ejecuté la solicitud, pero el modelo no devolvió una respuesta de texto. Prueba a precisar la pregunta o activa los logs de depuración para revisar el resultado de la herramienta.',
    'aiAssistant:fallback.noRows': 'No se encontraron registros para esta solicitud.',
    'aiAssistant:fallback.rowsFound': 'Filas encontradas: {count}.',
    'aiAssistant:taskFailed': 'Tarea del asistente IA fallida',
    'aiAssistant:settings.title': 'Asistente IA',
    'aiAssistant:settings.description': 'Configura el widget de chat flotante, el modelo y el comportamiento del asistente en el servidor.',
    'aiAssistant:settings.enabled': 'Activado',
    'aiAssistant:settings.disabled': 'Desactivado',
    'aiAssistant:settings.configured': 'Configurado',
    'aiAssistant:settings.apiKeyRequired': 'Se requiere clave API',
    'aiAssistant:settings.readOnly': 'Solo lectura',
    'aiAssistant:settings.provider': 'Proveedor: {provider}',
    'aiAssistant:settings.enableLabel': 'Activar asistente',
    'aiAssistant:settings.enableHint': 'Controla la visibilidad del widget flotante y el endpoint de chat.',
    'aiAssistant:settings.modelLabel': 'Modelo de OpenRouter',
    'aiAssistant:settings.apiKeyLabel': 'Clave API de OpenRouter',
    'aiAssistant:settings.apiKeyHint': 'Déjalo vacío para conservar la clave guardada en el servidor.',
    'aiAssistant:settings.systemPromptLabel': 'Sobrescribir prompt del sistema',
    'aiAssistant:settings.systemPromptPlaceholder': 'Instrucciones específicas del proyecto para el asistente (opcional)',
    'aiAssistant:settings.accessTitle': 'Modelo de acceso',
    'aiAssistant:settings.accessDescription': 'El asistente actual se limita a inspección de registros en modo solo lectura a través de acciones de recurso.',
    'aiAssistant:settings.futureToolsReady': 'Listo para futuras herramientas',
    'aiAssistant:settings.save': 'Guardar ajustes',
    'aiAssistant:settings.saving': 'Guardando…',
    'aiAssistant:settings.saved': 'Ajustes del asistente IA guardados',
    'aiAssistant:settings.empty': 'No hay ajustes disponibles.',
    'filter:op.co': 'Contiene',
    'filter:op.nco': 'No contiene',
    'filter:op.sw': 'Comienza con',
    'filter:op.ew': 'Termina con',
    'filter:op.eq': 'Es igual a',
    'filter:op.neq': 'No es igual a',
    'filter:op.empty': 'Está vacío',
    'filter:op.nempty': 'No está vacío',
    'filter:op.in': 'Es uno de',
    'filter:op.gt': 'Mayor que',
    'filter:op.lt': 'Menor que',
    'filter:op.between': 'Entre',
    'filter:searchValues': 'Buscar en lista…',
    'filter:selectAll': 'Seleccionar todo',
    'filter:noValues': 'No se encontraron valores',
    'common:newRecord': 'Nuevo {name}',
    'common:editRecord': 'Editar {name} #{id}',
    'common:themeLight': 'Claro',
    'common:themeDark': 'Oscuro',
    'common:themeSystem': 'Sistema',
    'common:ok': 'OK',
    'common:select': 'Seleccionar…',
    'common:removeItem': 'Eliminar {title}',
    'common:nSelectedAddMore': '{count} seleccionado(s) — agregar más',
    'common:pickRecords': 'Elegir registros',
    'common:managePickRecords': 'Gestionar selección ({count})',
    'common:pickRecordsFrom': 'Elegir de {name}',
    'common:draftRestored': 'Borrador no guardado restaurado',
    'common:undoDraftRestore': 'Deshacer',
    'aiFill:button': 'Rellenar con IA',
    'aiFill:dialogTitle': 'Rellenar formulario desde foto',
    'aiFill:dialogDescription': 'Sube una imagen — la IA extraerá los valores y rellenará el formulario.',
    'aiFill:fillButton': 'Reconocer',
    'aiFill:processing': 'Reconociendo imagen…',
    'aiFill:success': '{count} campo(s) rellenado(s)',
    'aiFill:errorNoFields': 'Este recurso no tiene campos rellenables por IA.',
    'aiFill:errorGeneric': 'Error al rellenar con IA: {message}',
    'aiFill:noValues': 'La IA no pudo extraer ningún valor de esta imagen.',
    'aiFill:applied': 'La IA rellenó {count} campo(s). Puedes deshacer abajo.',
    'wizard:stepOf': 'Paso {current} de {total}',
    'wizard:products.step1': 'Información básica',
    'wizard:products.step2': 'Precios',
    'wizard:products.step3': 'Medios y etiquetas',
    'common:invalidValue': 'Valor no válido',
    'common:collapseSidebar': 'Contraer barra lateral',
    'common:expandSidebar': 'Expandir barra lateral',
    'common:toggleSidebar': 'Alternar barra lateral',
    'common:sidebarTitle': 'Barra lateral',
    'common:sidebarNavigation': 'Menú de navegación',
    'cache:title': 'Caché',
    'cache:description': 'Estado de la caché y rendimiento por recurso en esta réplica.',
    'cache:load.error': 'No se pudieron cargar las métricas de caché',
    'cache:load.retry': 'Reintentar',
    'cache:reset.action': 'Restablecer métricas',
    'cache:reset.loading': 'Restableciendo métricas de caché…',
    'cache:reset.success': 'Métricas de caché restablecidas',
    'cache:reset.error': 'No se pudieron restablecer las métricas',
    'cache:metric.hitRate': 'Tasa de aciertos',
    'cache:metric.requests': 'Lecturas de caché',
    'cache:metric.avgCompute': 'Cálculo medio',
    'cache:metric.errors': 'Errores',
    'cache:unit.ms': '{value} ms',
    'cache:quarantine.title': 'Etiquetas en cuarentena',
    'cache:quarantine.description': 'Estas etiquetas omiten la caché hasta que la invalidación se complete.',
    'cache:invalidate.title': 'Invalidar caché del recurso',
    'cache:invalidate.description': 'Elimina listas y registros del recurso en todas las réplicas configuradas.',
    'cache:invalidate.resource': 'Recurso',
    'cache:invalidate.action': 'Invalidar caché',
    'cache:invalidate.loading': 'Invalidando caché…',
    'cache:invalidate.success': 'Caché del recurso invalidada',
    'cache:invalidate.error': 'No se pudo invalidar la caché del recurso',
    'cache:table.title': 'Métricas por espacio de nombres',
    'cache:table.empty': 'Aún no se registró actividad de caché.',
    'cache:instance': 'Réplica {id}',
    'cache:table.namespace': 'Espacio de nombres',
    'cache:table.resource': 'Recurso',
    'cache:table.hits': 'Aciertos',
    'cache:table.misses': 'Fallos',
    'cache:table.computes': 'Cálculos',
    'cache:table.coalesced': 'Agrupados',
    'cache:table.errors': 'Errores',
  },
}
